import React, { useState } from "react";
import Button from "../../UI/Button";
import ConfirmationModal from "../ConfirmationModal";
import {
    SelectContainer,
    Select,
    ConfirmationContent,
} from "../ModalStyledComponents";
import theme from "../../UI/theme";
import { Reservation as ReservationModel } from "../../calendar/model";
import { cancelReservation } from "../../store/data";
import { useDispatch } from "../../store/store";
import useCalendar from "../../calendar/context/useCalendar";
import { useTranslation } from "react-i18next";

interface Props {
    reservation: ReservationModel;
}

const Reservation = ({ reservation }: Props) => {
    const { t } = useTranslation();

    const { inputCallbacks } = useCalendar();
    const dispatch = useDispatch();
    const [isConfirmationOpen, setConfirmationOpen] = useState(false);
    const [reasonId, setReasonId] = useState("0");
    const [showWarning, setShowWarning] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setShowWarning(e.target.value === "0");
        setReasonId(e.target.value);
    };

    const handleCancelClick = () => {
        if (reasonId === "0") {
            setShowWarning(true);
            return;
        }
        setConfirmationOpen(true);
    };

    const handleCancelConfirm = () => {
        setConfirmationOpen(true);
        dispatch(cancelReservation(reservation.id));
        void inputCallbacks.onCancelReservation(reservation.id, reasonId);
        setConfirmationOpen(false);
    };

    return (
        <>
            <div>{`${reservation.start} - ${reservation.end}`}</div>
            <div>
                {t('patient')}: <strong>{reservation.patient}</strong>
            </div>
            <div>
                {t('birth_date')}: <strong>{reservation.born}</strong>
            </div>
            <div>
                {t('qualification')}: <strong>{reservation.service}</strong>
            </div>
            <div>
                {t('specialization')}: <strong>{reservation.speciality}</strong>
            </div>
            <SelectContainer>
                <Select value={reasonId} onChange={handleChange}>
                    <option disabled value="0">
                        {t('choose')}
                    </option>
                    <option value="1">{t('from_patient')}</option>
                    <option value="2">{t('from_institution')}</option>
                    <option value="3">{t('patient_didnt_show_up')}</option>
                    {reservation.video_consultation && (
                        <option value="4">{t('technical_issue')}</option>
                    )}
                    <option value="5">{t('payment_by_ep_card')}</option>
                </Select>
                <Button onClick={handleCancelClick} className="btn-danger">
                    {t('cancel')}
                </Button>
            </SelectContainer>
            {showWarning && (
                <strong style={{ color: theme.colors.red }}>
                    {t('select_cancel_reason')}
                </strong>
            )}
            {isConfirmationOpen && (
                <ConfirmationModal
                    title={t('confirm_cancel')}
                    confirmLabel={t('cancel')}
                    cancelLabel={t('back')}
                    open={true}
                    onClose={() => setConfirmationOpen(false)}
                    onCancel={() => setConfirmationOpen(false)}
                    onConfirm={handleCancelConfirm}
                >
                    <ConfirmationContent>
                        {t('selected_reservation_deleted')}
                    </ConfirmationContent>
                </ConfirmationModal>
            )}
        </>
    );
};

export default Reservation;
